import React from 'react';
import { Truck, FileText, ShieldAlert, MapPin, Radar, Wrench } from 'lucide-react';
export function CoreModulesSlide() {
  const modules = [{
    title: 'Fleet & Asset Management',
    icon: Truck,
    points: ['Clients (multi-level hierarchy)', 'Vehicles, drivers, assignments', 'Document management & bulk operations']
  }, {
    title: 'Leasing & Agreements',
    icon: FileText,
    points: ['Lease lifecycle management', 'Vehicle assignment & replacement', 'Microsoft Dynamics 365 integration']
  }, {
    title: 'Fines & Enforcement',
    icon: ShieldAlert,
    points: ['Traffic fines & black points tracking', 'Vehicle & driver linking', 'Impounding management & payment']
  }, {
    title: 'Live Tracking & Telematics',
    icon: MapPin,
    points: ['Real-time GPS tracking (multi-provider)', 'Device control (immobilizer, commands)', 'Live streaming and location updates']
  }, {
    title: 'Geofencing & Violations',
    icon: Radar,
    points: ['Zone-based tracking and alerts', 'Police custody zones integration', 'Automated violation detection']
  }, {
    title: 'Workshops & Service',
    icon: Wrench,
    points: ['Service booking & scheduling', 'Workshop operations & technician assignment', 'Maintenance lifecycle tracking']
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-8 py-6" data-id="element-175">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-176">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-177" />
      </div>

      {/* Title */}
      <div className="text-center shrink-0 mb-6 mt-2" data-id="element-178">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-179">
          Platform Modules
        </span>
        <h1 className="text-[1.25rem] font-bold text-[#1a1a2e] mt-1" data-id="element-180">
          Pair2 Platform – Core Operational Modules
        </h1>
      </div>

      {/* Main Grid */}
      <div className="flex-grow flex items-center justify-center w-full max-w-7xl mx-auto" data-id="element-181">
        <div className="grid grid-cols-3 gap-5 w-full" data-id="element-182">
          {modules.map((mod, idx) => <div key={idx} className="bg-gray-50/50 border border-gray-100 rounded-xl p-5 flex flex-col hover:shadow-md transition-shadow duration-300" data-id="element-183">
              <div className="flex items-center gap-3 mb-4" data-id="element-184">
                <div className="w-10 h-10 rounded-lg bg-[#2EBCB0]/10 text-[#2EBCB0] flex items-center justify-center shrink-0" data-id="element-185">
                  <mod.icon className="w-5 h-5" data-id="element-186" />
                </div>
                <h3 className="font-bold text-[0.85rem] text-[#1a1a2e] leading-tight" data-id="element-187">
                  {mod.title}
                </h3>
              </div>
              <ul className="space-y-2.5 mt-auto" data-id="element-188">
                {mod.points.map((point, pIdx) => <li key={pIdx} className="flex items-start gap-2" data-id="element-189">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#2EBCB0] mt-1.5 shrink-0" data-id="element-190" />
                    <span className="text-[0.75rem] text-gray-600 leading-snug" data-id="element-191">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0 mt-4" data-id="element-192">
        <p className="text-[0.75rem] italic text-gray-400" data-id="element-193">
          "A complete operational backbone for managing fleets, drivers, and
          compliance."
        </p>
      </div>
    </div>;
}